/** @jsx jsx */
import { jsx } from "theme-ui";
import React from "react";
import { ButtonProps } from "./Button";
import RockitLink from "../link/rockit-link";

export const LinkButton: React.FC<ButtonProps> = ({
  label,
  internallink: internalLink,
  variant,
  openInNewTab = false,
}) => {
  return (
    <RockitLink
      sx={{
        variant: `buttons.${variant.toLowerCase()}`,
      }}
      to={internalLink || "/"}
      openInNewTab={openInNewTab}
    >
      <span>{label}</span>
    </RockitLink>
  );
};

export default LinkButton;
